<div class="modal fade" id="dialogImprimir" tabindex="-1" role="dialog" aria-labelledby="Imprimir" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title">Adiantamento</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-row">
          <div class="form-group col-4">
            <label for="data_inicio">Período</label>
            <p-calendar [(ngModel)]="dataInicio" id="data_inicio" 
            inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
            [showButtonBar]="true" [style]="{ width: '100%' }">
            </p-calendar>
          </div>
          <div class="form-group col-4">
            <label for="data_final">&nbsp;</label>
            <p-calendar [(ngModel)]="dataFinal" id="data_final" 
            inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
            [showButtonBar]="true" [style]="{ width: '100%' }">
            </p-calendar>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-12">
            <p-radioButton name="groupname" value="ord1" label="Ordem de número de adiantamento" [(ngModel)]="selectedOrdem">
            </p-radioButton>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12">
            <p-radioButton name="groupname" value="ord2" label="Ordem razão social" [(ngModel)]="selectedOrdem">
            </p-radioButton>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="imprimir()" type="button" class="btn btn-secondary" id="btnImp" data-dismiss="modal">Imprimir</button>
        <button type="button" class="btn btn-link" id="btnCancelar" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>
